import React from "react";
import ReactDOM from "react-dom";
import App from './app';

// Bloque Color Selector (#color-selector-root) y pestaña 360° de la galería de
// detalles ([data-color-selector]). El bundle puede cargarse más de una vez en
// la misma página, así que cada raíz se marca al montarla.
const rootElements = document.querySelectorAll("#color-selector-root, [data-color-selector]");
rootElements.forEach(rootElement => {
    if (rootElement.dataset.colorSelectorMounted) return;
    rootElement.dataset.colorSelectorMounted = "1";

    const versionId = rootElement.dataset.version;
    const title = rootElement.dataset.title;
    ReactDOM.render(<App versionId={versionId} title={title} />, rootElement);
});
